import styled from "styled-components";
export const BreadStyle = styled.div`
  nav {
    direction: rtl !important;
  }
  .breadcrumb-item {
    font-weight: bold;
    font-size: 13px;
    &::before {
      float: right !important;
      /* padding-right: 0.5rem !important; */
      padding-left: 0.5rem !important;
    }
  }
  a {
    color: #009ef7 !important;
  }
`;
